var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Subject } from '@/models/Subject';
import SubjectRow from '@/components/subject-row/SubjectRow';
import { Model } from '@/models/Model';
import { RolesEnum } from '@/items/Roles';
let SubjectSearchDialog = class SubjectSearchDialog extends Vue {
    constructor() {
        super(...arguments);
        this.selectedSubject = null;
        this.subjects = [];
        this.selectedSubjects = [];
        this.invitations = {};
        this.subjectSearch = '';
        this.isLoading = false;
    }
    mounted() {
        // this.fetchSelectedSubjects();
    }
    clear() {
        this.selectedSubject = null;
    }
    searchChanged(search, oldSearch) {
        if (typeof search !== 'string' || search.length === 0) {
            this.subjects = [];
            return;
        }
        if (search.length > 2) {
            this.$debounce('getSubjects');
        }
    }
    // protected fetchSelectedSubjects() {
    //   this.selectedSubjects = new Model().dataToModel({}, 'Subject', this.$store.state.selected);
    // }
    getSubjects() {
        this.isLoading = true;
        new Subject()
            .filter({
            depth: 2,
            search: this.subjectSearch,
            archived: false,
            periods: this.filters.periods,
            levels: this.filters.levels,
        })
            .include(['level', 'period', 'parent'])
            .all()
            .then((subjects) => {
            this.$nextTick(() => {
                this.subjects = new Model().dataToModel({}, 'Subject', subjects);
            });
            this.isLoading = false;
        })
            .catch(() => {
            this.isLoading = false;
        });
    }
    close() {
        this.$emit('input', false);
    }
    save() {
        this.close();
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([
            RolesEnum.ADMIN,
            RolesEnum.ROOT,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
            RolesEnum.TEACHER,
        ]);
    }
};
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], SubjectSearchDialog.prototype, "eventVisible", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], SubjectSearchDialog.prototype, "hardlocked", void 0);
__decorate([
    Prop({ default: { periods: [], levels: [] } }),
    __metadata("design:type", Object)
], SubjectSearchDialog.prototype, "filters", void 0);
__decorate([
    Watch('subjectSearch'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], SubjectSearchDialog.prototype, "searchChanged", null);
SubjectSearchDialog = __decorate([
    Component({
        components: {
            SubjectRow,
        },
    })
], SubjectSearchDialog);
export default SubjectSearchDialog;
